import apiClient from './api/apiClient'
import { APIEndpoints } from './api/apiConfig'

let employee = null

export async function getEmployee(employeeId, force) {
  if (!employeeId) {
    return null
  }
  if (!force && employee && employee.id === employeeId) {
    return employee
  }

  try {
    employee = await apiClient.getJson(
      APIEndpoints.businessPartner(employeeId).info
    )
    return employee
  } catch (error) {
    console.error(`Failed to load employee ${employeeId}:`, error.message)
    return null
  }
}
